import React from 'react';

type StatusVariant =
  | 'APPROVED' | 'PENDING_APPROVAL' | 'REJECTED' | 'DRAFT' |'ISSUED'| 'ACTIVE' | 'EXPIRING_SOON' | 'EXPIRED' | 'DEPLETED' |'QUARANTINED'| 'COMPLETED' | 'CANCELLED' | 'IN_TRANSIT' |'PENDING' | 'LOW' | 'CRITICAL' | 'HEALTHY' | 'OUT_OF_STOCK';

const VARIANT_STYLES: Record<StatusVariant, string> = {
  APPROVED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  ACTIVE: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  HEALTHY: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  PENDING_APPROVAL: 'bg-amber-50 text-amber-700 border-amber-200',
  PENDING: 'bg-amber-50 text-amber-700 border-amber-200',
  EXPIRING_SOON: 'bg-amber-50 text-amber-700 border-amber-200',
  LOW: 'bg-amber-50 text-amber-700 border-amber-200',
  REJECTED: 'bg-red-50 text-red-700 border-red-200',
  EXPIRED: 'bg-red-50 text-red-700 border-red-200',
  CRITICAL: 'bg-red-50 text-red-700 border-red-200',
  OUT_OF_STOCK: 'bg-red-50 text-red-700 border-red-200',
  DRAFT: 'bg-slate-100 text-slate-600 border-slate-200',
  CANCELLED: 'bg-slate-100 text-slate-600 border-slate-200',
  ISSUED: 'bg-blue-50 text-blue-700 border-blue-200',
  IN_TRANSIT: 'bg-blue-50 text-blue-700 border-blue-200',
  DEPLETED: 'bg-gray-100 text-gray-500 border-gray-200',
  QUARANTINED: 'bg-purple-50 text-purple-700 border-purple-200',
};

const VARIANT_LABELS: Record<StatusVariant, string> = {
  APPROVED: 'Approved',
  ACTIVE: 'Active',
  HEALTHY: 'Healthy',
  COMPLETED: 'Completed',
  PENDING_APPROVAL: 'Pending Approval',
  PENDING: 'Pending',
  EXPIRING_SOON: 'Expiring Soon',
  LOW: 'Low Stock',
  REJECTED: 'Rejected',
  EXPIRED: 'Expired',
  CRITICAL: 'Critical',
  OUT_OF_STOCK: 'Out of Stock',
  DRAFT: 'Draft',
  CANCELLED: 'Cancelled',
  ISSUED: 'Issued',
  IN_TRANSIT: 'In Transit',
  DEPLETED: 'Depleted',
  QUARANTINED: 'Quarantined',
};

interface StatusBadgeProps {
  status: StatusVariant;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const styles = VARIANT_STYLES[status] ?? 'bg-gray-100 text-gray-600 border-gray-200';
  const label = VARIANT_LABELS[status] ?? status;
  return (
    <span
      className={`inline-flex items-center border rounded-full font-500 whitespace-nowrap ${styles} ${
        size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1'
      }`}
    >
      {label}
    </span>
  );
}